/* eslint-disable no-mixed-operators */

import moment from 'moment';

import { t } from 'util/i18n';

export const normalizePrice = price => Math.round(price / 100) * 100;

export const calculateRent = roomData => ({
	deposit: roomData.deposit,
	shortRent: normalizePrice(roomData.price * 1.6),
	middleRent: normalizePrice(roomData.price * 1.3),
	rent: roomData.price,
});

export const calculateMonth = (
	range,
	yearRange,
	{ excludeLastMonth } = { excludeLastMonth: true },
) => {
	if (range.length === 0 || yearRange.length === 0) {
		return 0;
	}

	if (range.length < 2 || yearRange.length < 2) {
		return 1;
	}

	const dumpNumber = excludeLastMonth ? 1 : 0;

	return range[1] - range[0] + 1 + 12 * (yearRange[1] - yearRange[0]) - dumpNumber;
};

export const ORDER_ITEM_PET_ID = 1;
export const ORDER_ITEM_EXTRA_PERSON_ID = 2;
export const ORDER_ITEM_PET_CLEANING_FEE_ID = 3;

export const calculateCheckinTime = (events, lan) => {
	const [{ work_date: workDate } = { work_date: '' }] = events.filter(
		event =>
			['VERIFY', 'RESERVED', 'SUCCESS'].includes(event.status) && event.event_type === 'CHECKIN',
	);

	if (workDate === '') {
		return '';
	}

	const startTime = moment(workDate);
	const endTime = moment(workDate).add(15, 'm');

	return `${startTime.format(
		lan === 'en' ? 'MMM/DD/YYYY HH:mm' : 'YYYY/MM/DD HH:mm',
	)} - ${endTime.format('HH:mm')}`;
};

export const calculateRoomStatus = (roomData, lan) => {
	if (roomData.hasProcessingOrder === null) {
		return { date: '', available: t('bookingBar:available'), isAvailable: true };
	}

	if (roomData.canOrderStart === null) {
		return { date: '', available: t('bookingBar:available'), isAvailable: true };
	}

	const canOrderStart = moment(roomData.canOrderStart);

	if (roomData.canBooking) {
		return {
			date: t('bookingBar:releaseTime', {
				YYYY: canOrderStart.format('YYYY'),
				MM: canOrderStart.format(lan === 'en' ? 'MMM' : 'MM'),
				DD: canOrderStart.format('DD'),
			}),
			available: t('bookingBar:available'),
			isAvailable: true,
		};
	}

	return {
		date: '',
		available: t('bookingBar:notAvailable'),
		isAvailable: false,
	};
};



// WEBPACK FOOTER //
// ./src/util/rent.js